"use client";

import { useHovercard } from "../__chunks/QLQGB5A3.js";
import "../__chunks/X7QOZUD3.js";
import "../__chunks/DUIQBYXB.js";
import { createDialogComponent } from "../__chunks/YLXVVG22.js";
import "../__chunks/RYNM3PZY.js";
import "../__chunks/D7GLA236.js";
import "../__chunks/IGR4SXG2.js";
import "../__chunks/ESSM74HH.js";
import "../__chunks/TBGPDHVR.js";
import "../__chunks/IT6VQU5B.js";
import "../__chunks/7V5QX4SZ.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/2PGBN2Y4.js";
import "../__chunks/63XF7ACK.js";
import "../__chunks/AOUGVQZ3.js";
import "../__chunks/K2ZF5NU7.js";
import "../__chunks/SCDU7JWG.js";
import "../__chunks/EGBLFVR2.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/OJXDGVKQ.js";
import "../__chunks/ND57YZ3V.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/UYRBEP7M.js";
import "../__chunks/5HEBF2AL.js";
import { TooltipScopedContextProvider, useTooltipProviderContext } from "../__chunks/IEMWKLTV.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/2ATXICAB.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/B5WJDZ55.js";
import "../__chunks/C76P7QQC.js";
import "../__chunks/CTKPPFRS.js";
import { useWrapElement } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip.tsx
import { contains } from "@ariakit/core/utils/dom";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useTooltip = createHook(function useTooltip2(_a) {
  var _b = _a,
    store = _b.store,
    _b$portal = _b.portal,
    portal = _b$portal === void 0 ? true : _b$portal,
    _b$gutter = _b.gutter,
    gutter = _b$gutter === void 0 ? 8 : _b$gutter,
    _b$preserveTabOrder = _b.preserveTabOrder,
    preserveTabOrder = _b$preserveTabOrder === void 0 ? false : _b$preserveTabOrder,
    _b$hideOnHoverOutside = _b.hideOnHoverOutside,
    _hideOnHoverOutside = _b$hideOnHoverOutside === void 0 ? true : _b$hideOnHoverOutside,
    _b$hideOnInteractOuts = _b.hideOnInteractOutside,
    _hideOnInteractOutside = _b$hideOnInteractOuts === void 0 ? true : _b$hideOnInteractOuts,
    props = __objRest(_b, ["store", "portal", "gutter", "preserveTabOrder", "hideOnHoverOutside", "hideOnInteractOutside"]);
  var context = useTooltipProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component.");
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(TooltipScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  var role = store.useState(function (state) {
    return state.type === "description" ? "tooltip" : "none";
  });
  props = __spreadValues({
    role: role
  }, props);
  props = useHovercard(__spreadProps(__spreadValues({}, props), {
    store: store,
    portal: portal,
    gutter: gutter,
    preserveTabOrder: preserveTabOrder,
    hideOnHoverOutside: function hideOnHoverOutside(event) {
      if (isFalsyBooleanCallback(_hideOnHoverOutside, event)) return false;
      var anchorElement = store == null ? void 0 : store.getState().anchorElement;
      if (!anchorElement) return true;
      if ("focusVisible" in anchorElement.dataset) return false;
      return true;
    },
    hideOnInteractOutside: function hideOnInteractOutside(event) {
      if (isFalsyBooleanCallback(_hideOnInteractOutside, event)) return false;
      var anchorElement = store == null ? void 0 : store.getState().anchorElement;
      if (!anchorElement) return true;
      if (contains(anchorElement, event.target)) return false;
      return true;
    }
  }));
  return props;
});
var Tooltip = createDialogComponent(forwardRef(function Tooltip2(props) {
  var htmlProps = useTooltip(props);
  return createElement(TagName, htmlProps);
}), useTooltipProviderContext);
export { Tooltip, useTooltip };